import { useSearchParams } from '@mntn-dev/app-navigation'
import type { ClientFlags } from '@mntn-dev/flags-types'
import { literalKeys } from '@mntn-dev/utilities'
import { useMemo } from 'react'
import type { Writable } from 'type-fest'

/** Return a partial ClientFlags hydrated from query string params matching keyof ClientFlags. */
export function useQueryFlags(flags: ClientFlags) {
  const searchParams = useSearchParams()

  return useMemo(
    () =>
      literalKeys<keyof ClientFlags>(flags).reduce<
        Writable<Partial<ClientFlags>>
      >((acc, key) => {
        const value = searchParams.get(key)
        if (value) {
          // biome-ignore lint/suspicious/noExplicitAny: ClientFlags has a mix of property types. Only need to override boolean flags.
          acc[key] = value === 'true' ? true : (null as any)
        }

        return acc
      }, {}),
    [flags, searchParams]
  )
}
